'use client'
import { SxProps, Typography, styled } from '@mui/material'
import React, { ReactNode } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { colors } from '../../Theme/LegacyTheme'

interface HeadingWithParagraphsProps {
  title: string
  paragraphs: string[] | ReactNode
  centerHeader?: boolean
  styleOverrides?: SxProps
  sectionId?: string
  hasAnchor?: boolean
}

const HeadingParagraphBlock = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(7),
  '& > h2 > a': {
    color: colors.black,
    textDecoration: 'underline'
  }
}))

const HeadingWithParagraphs: React.FC<HeadingWithParagraphsProps> = ({
  title,
  paragraphs,
  centerHeader,
  styleOverrides,
  sectionId,
  hasAnchor = false
}) => {
  return (
    <HeadingParagraphBlock sx={{ ...styleOverrides }} id={sectionId}>
      <Typography variant="h2" className={[centerHeader ? 'text-center' : ''].join(' ')}>
        {hasAnchor ? <a href={`#${sectionId}`}>{title}</a> : title}
      </Typography>
      <div>
        {Array.isArray(paragraphs) && paragraphs.every((paragraph) => typeof paragraph === 'string')
          ? (paragraphs as string[]).map((paragraph) => (
              <Typography variant="body1" key={uuidv4()}>
                {paragraph}
              </Typography>
            ))
          : <Typography variant="body1">{paragraphs as ReactNode}</Typography>}
      </div>
    </HeadingParagraphBlock>
  )
}

export default HeadingWithParagraphs
